{
    "WHATSAPP_TEMPLATES": {
        "MODAL": {
            "TITLE": "WhatsApp-pohjat",
            "SUBTITLE": "Valitse WhatsApp-pohja, jonka haluat lähettää",
            "TEMPLATE_SELECTED_SUBTITLE": "Process {templateName}"
        },
        "PICKER": {
            "SEARCH_PLACEHOLDER": "Etsi Pohjia",
            "NO_TEMPLATES_FOUND": "No templates found for",
            "LABELS": {
                "LANGUAGE": "Language",
                "TEMPLATE_BODY": "Template Body",
                "CATEGORY": "Category"
            }
        },
        "PARSER": {
            "VARIABLES_LABEL": "Muuttujat",
            "VARIABLE_PLACEHOLDER": "Enter {variable} value",
            "GO_BACK_LABEL": "Mene Takaisin",
            "SEND_MESSAGE_LABEL": "Lähetä Viesti",
            "FORM_ERROR_MESSAGE": "Täytä kaikki muuttujat ennen lähettämistä"
        }
    }
}
